import type { NotificationTypeEnum } from '@maestro/commerce-blocks/components/notification/notification.types'
import type { JSX, ReactNode } from 'react'

export type ProviderType<T> = ({
  children,
  config,
}: {
  children: ReactNode
  config: T
}) => JSX.Element

// keys of this enum must match keys of RecommendationPageType, defined in recommendation package
export enum RecommendationPlacementType {
  PRODUCT = 'pdp',
  CATEGORY = 'plp',
  BRAND = 'brand',
  CART = 'cart',
  MY_ACCOUNT = 'my_account',
  NOT_FOUND = 'not_found',
  SEARCH = 'search',
  SEARCH_NOT_FOUND = 'search_not_found',
  ORDERS = 'orders',
}

export interface RecommendationComponentProps {
  pageType: string
  id?: string
  recommendationPlacementType?: string
  selectorNames?: string[]
  displayType?: RecommendationDisplayType
  addToCartType?: AddToCartType
  addToCartTitle?: string
  showLoadingSkeleton?: boolean
  showWishlistButton?: boolean
  addToCartNotificationType?: NotificationTypeEnum
  // allows to inform outer component when recommendations has been loaded
  setIsLoaded?: (isLoaded: boolean) => void
  titleCustomColorClass?: string
  title?: string
  fetchFilters?: Record<string, string | number>
}

export enum RecommendationDisplayType {
  SLIDER = 'slider',
  LIST = 'list',
}

export enum AddToCartType {
  BUTTON = 'button',
  ICON = 'icon',
  NONE = 'none',
}

export type RecommendationComponentType = (
  props: RecommendationComponentProps
) => JSX.Element
